import React, { useEffect, useState } from "react";
// import { BiCopy } from "react-icons/bi";

export default function Contact({ data }) {
  /*const profile = data.profile?.[0] || {};
  const [copied, setCopied] = useState(false);*/
  //const [showForm, setShowForm] = useState(false);
  const [formLoading, setFormLoading] = useState(false);

  useEffect(() => {
    const existing = document.querySelector("script[data-tf-script]");
    if (existing) {
      if (window.tf && typeof window.tf.load === "function") {
        window.tf.load();
      }
      return;
    }
    const script = document.createElement("script");
    script.src = "//embed.typeform.com/next/embed.js";
    script.async = true;
    script.setAttribute("data-tf-script", "true");
    script.onload = () => {
      if (window.tf && typeof window.tf.load === "function") {
        window.tf.load();
      }
    };
    document.body.appendChild(script);
  }, []);

  /*useEffect(() => {
    if (!showForm) {
      return;
    }
    if (window.tf && typeof window.tf.load === "function") {
      window.tf.load();
    }
    const timeout = setTimeout(() => setFormLoading(false), 1600);
    return () => clearTimeout(timeout);
  }, [showForm]);
*/
  /*const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(profile.mail || "");
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      setCopied(false);
    }
  };

  const handleToggleForm = () => {
    setShowForm((prev) => !prev);
    setFormLoading(true);
    const el = document.getElementById("contact-form");
    if (el) {
      setTimeout(() => {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 150);
    }
  };
*/
  document.title = "Contact - Aritra";

  return (
    <div className="page container-narrow">
      <section className="section">
        <p className="eyebrow">Contact</p>
        <h2 className="section-title">Let's build something together</h2>
        <p className="muted">
          I'm open to internships, freelance projects, and collaboration opportunities.
        </p>
      </section>

      <section className="section-tight">
        <div className="row g-4">
          <div className="col-lg-8">
            {/* Reach me directly card removed for now */}
            <div id="contact-form" className="contact-form-panel p-4">
              {formLoading && (
                <div className="typeform-loader">
                  <div className="spinner"></div>
                  <p>Loading form…</p>
                </div>
              )}
              <div
                className="typeform-embed"
                data-tf-live="01KNCKQ1BJXQFJ0E79KFF4TQJV"
                data-tf-on-ready={() => setFormLoading(false)}
              ></div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
